
import { Component, Vue, Prop } from 'vue-property-decorator';
import { CurrencyHelper } from '@/helpers/CurrencyHelper';
import {
  MonthlySalesData,
  SalesData,
  ProfitAnalysis,
  VariantSummary,
} from '@/types/productAnalysis';

@Component({
  name: 'AnalysisContent',
})
export default class AnalysisContent extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly salesData!: SalesData;
  @Prop({ type: Object, default: () => ({}) }) readonly profitAnalysis!: ProfitAnalysis;
  @Prop({ type: Array, default: () => [] }) readonly insights!: string[];
  @Prop({ type: Boolean, default: false }) readonly showVariantSummary!: boolean;
  @Prop({ type: Array, default: () => [] }) readonly variantsSummary!: VariantSummary[];

  /** Expose CurrencyHelper to template */
  CurrencyHelper = CurrencyHelper;

  /** Table headers for sales data */
  private salesTableHeaders = [
    { text: 'Month', value: 'month', sortable: false, width: '120px' },
    { text: 'Units Sold', value: 'units_sold', align: 'center', sortable: false, width: '100px' },
    { text: 'Revenue', value: 'revenue', align: 'right', sortable: false, width: '120px' },
    { text: 'COGS', value: 'cogs', align: 'right', sortable: false, width: '100px' },
    { text: 'Profit', value: 'profit', align: 'right', sortable: false, width: '100px' },
    { text: 'Margin %', value: 'margin_pct', align: 'center', sortable: false, width: '100px' },
  ];

  /** Table headers for variant summary */
  private variantSummaryHeaders = [
    { text: 'Variant', value: 'variant_name', sortable: false },
    { text: 'SKU', value: 'sku', sortable: false, width: '100px' },
    { text: 'Units', value: 'total_units', align: 'right', sortable: false, width: '100px' },
    { text: 'Revenue', value: 'total_revenue', align: 'right', sortable: false, width: '130px' },
    { text: 'Margin', value: 'gross_margin_pct', align: 'center', sortable: false, width: '100px' },
  ];

  /** Get monthly data from sales data */
  get monthlyData(): MonthlySalesData[] {
    return this.salesData?.monthly_data || [];
  }
}
